<script>

    import 'flatpickr/dist/flatpickr.css'
    import { Spanish } from 'flatpickr/dist/l10n/es.js'
    import Moment from 'moment'
    import Flatpickr from 'svelte-flatpickr'
    import { createEventDispatcher } from 'svelte'

    export let day = ''

    const dispatch = createEventDispatcher()

    let open = false

    $: date = asDate(day)
    $: pickerOptions = {
        inline: true,
        enableTime: false,
        locale: Spanish,
        defaultDate: date,
    }

    function asDate(value) {
        const [year, month, date] = String(value || '').split('-').map(Number)
        if (!year || !month || !date) return new Date()
        return new Date(year, month - 1, date)
    }

    function toDay(value) {
        const month = String(value.getMonth() + 1).padStart(2, '0')
        const date = String(value.getDate()).padStart(2, '0')
        return `${value.getFullYear()}-${month}-${date}`
    }

    function formatDate(value) {
        return Moment(asDate(value)).locale('es').format('DD MMM YYYY')
    }

    function shift(delta) {
        const [year, month, date] = String(day || '').split('-').map(Number)
        if (!year || !month || !date) return
        open = false
        dispatch('change', new Date(Date.UTC(year, month - 1, date + delta)).toISOString().slice(0, 10))
    }

    function onPickerChange(event) {
        const picked = event.detail && event.detail[0]
        if (!picked) return
        open = false
        dispatch('change', toDay(picked))
    }

    function clickOutside(node, onClose) {
        const onClick = (event) => {
            if (!node.contains(event.target) && !event.target.closest('.date-day-nav__date'))
                onClose()
        }

        setTimeout(() => document.addEventListener('click', onClick), 0)

        return {
            destroy() {
                document.removeEventListener('click', onClick)
            },
        }
    }

</script>

<style>
    .date-day-nav {
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;
        user-select: none;
    }

    .date-day-nav__arrow,
    .date-day-nav__date {
        background: none;
        border: none;
        cursor: pointer;
        color: #3a3a3a;
        line-height: 1;
        padding: 0.35rem 0.5rem;
        border-radius: 6px;
        transition: background 0.15s ease, color 0.15s ease;
    }

    .date-day-nav__arrow {
        font-size: 13px;
        padding: 0.35rem 0.4rem;
        color: #888;
    }

    .date-day-nav__arrow:hover,
    .date-day-nav__date:hover,
    .date-day-nav__date.is-active {
        background: #f4f4f4;
        color: #1a1a1a;
    }

    .date-day-nav__dates {
        position: relative;
        display: inline-flex;
        align-items: center;
    }

    .date-day-nav__date {
        font-size: 14px;
        font-weight: 600;
        text-transform: capitalize;
    }

    .date-day-nav__popover {
        position: absolute;
        top: calc(100% + 6px);
        left: 50%;
        transform: translateX(-50%);
        z-index: 20;
        background: #fff;
        border: 1px solid #e8e8e8;
        border-radius: 8px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
        overflow: hidden;
    }

    .date-day-nav__popover :global(.flatpickr-calendar) {
        box-shadow: none;
    }
</style>

<div class="date-day-nav">
    <button type="button" class="date-day-nav__arrow" aria-label="Día anterior" on:click={() => shift(-1)}>
        <i class="fas fa-chevron-left"></i>
    </button>

    <div class="date-day-nav__dates">
        <button
            type="button"
            class="date-day-nav__date"
            class:is-active={open}
            on:click|stopPropagation={() => open = !open}
        >
            {formatDate(day)}
        </button>

        {#if open}
            <div class="date-day-nav__popover" use:clickOutside={() => open = false}>
                <Flatpickr value={date} options={pickerOptions} on:change={onPickerChange} />
            </div>
        {/if}
    </div>

    <button type="button" class="date-day-nav__arrow" aria-label="Día siguiente" on:click={() => shift(1)}>
        <i class="fas fa-chevron-right"></i>
    </button>
</div>
